export default __webpack_public_path__ + "static/media/influencer_profile02.5f41b620.svg";